// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import curry from 'lodash/curry';

const DEFAULT_FLOW = 'basic';
const noop = () => undefined;

function onDialogSuccess(callback, identity) {
  /* this will only be called on the client in response to user action
     so we know window will be available. */
  const setHeaderProps = get(window, 'nerdwallet.ui.setHeaderProps', noop);
  setHeaderProps({
    isSignedIn: get(identity, 'isSignedIn'),
    firstName: get(identity, 'profiles.global_profile.first_name'),
  });
  callback(identity);
}

/**
 * Wrapper around window.nwapi.ui.showAuthEmbed.
 * Note: Setting isNonDismissible will prevent onDialogDismissed from being called
 * @see https://github.com/NerdWallet/nw-auth-dialog
 * @param {string} [flow='basic']
 * @param {function} [onSuccess=noop] - called when user signs-in/signs-up successfully
 * @param {function} [onUserDismiss=noop] - called if the user closes the dialog without signing up
 * @param {Object} [trk] - tracking info
 * @param {boolean} [isNonDismissible] - if set to true, will hide the close button.
 * @returns {Promise} - A promise that resolves into the dialog instance.
 */
export default function showAuthEmbed(opts) {
  const {
    flow = DEFAULT_FLOW,
    trk,
    onSuccess = noop,
    onUserDismiss = noop,
    isNonDismissible,
    containerId,
  } = opts;

  if (typeof window === 'undefined') {
    return;
  }

  window.nwapi.onReady(() => {
    const args = {
      flow,
      version: 2,
      trk,
      onSuccess: curry(onDialogSuccess)(onSuccess),
      onUserDismiss: isNonDismissible ? false : onUserDismiss,
      el: document.getElementById(containerId),
    };

    window.nwapi.ui.showAuthEmbed(args);
    window.scrollTo(0, 0);
  });
}
